"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _kycConfigShapePropTypes = require("../../propTypes/kycConfigShapePropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var kycClasses = (0, _cssClassesHelper.getBEMClasses)('kyc-settings');
var KYCBaseComponent = /*#__PURE__*/function (_React$Component) {
  function KYCBaseComponent() {
    _classCallCheck(this, KYCBaseComponent);
    return _callSuper(this, KYCBaseComponent, arguments);
  }
  _inherits(KYCBaseComponent, _React$Component);
  return _createClass(KYCBaseComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        userId = _this$props.userId,
        userName = _this$props.userName,
        getUserConfig = _this$props.getUserConfig;
      if (!prevProps.userId && !prevProps.userName && userId && userName) {
        getUserConfig(userId, userName);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        kycConfig = _this$props2.kycConfig,
        verificationLevel = _this$props2.verificationLevel,
        levelIncreaseStatus = _this$props2.levelIncreaseStatus,
        LevelsComponent = _this$props2.LevelsComponent,
        highlightStyle = _this$props2.highlightStyle;
      var levels = (0, _get["default"])(kycConfig, 'levels', []);
      var level1 = levels[0];
      var level2 = levels[1];
      var level3 = levels[2];
      var level4 = levels[3];
      var KYCWorkflowLevelsComponentProps = {
        highlightStyle: highlightStyle,
        verificationLevel: verificationLevel,
        levelIncreaseStatus: levelIncreaseStatus,
        levels: levels,
        level1: level1,
        level2: level2,
        level3: level3,
        level4: level4
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(kycClasses('', highlightStyle))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('header')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('header-text')
      }, t("Current Verification Level")), /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('description')
      }, t("For your security, some of our services require you to provide basic or additional levels of verification.")), /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('description')
      }, t("To verify your account or to check what your current verification level is, see below."))), /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('levels')
      }, /*#__PURE__*/_react["default"].createElement(LevelsComponent, KYCWorkflowLevelsComponentProps)));
    }
  }]);
}(_react["default"].Component);
KYCBaseComponent.propTypes = {
  userId: _propTypes["default"].number,
  userName: _propTypes["default"].string,
  values: _propTypes["default"].object,
  verificationLevel: _propTypes["default"].number,
  levelIncreaseStatus: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  openKYCSidePane: _propTypes["default"].func,
  kycConfig: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    levels: _propTypes["default"].arrayOf(_propTypes["default"].shape(_kycConfigShapePropTypes.kycConfigLevelShape))
  })
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("kyc")(KYCBaseComponent);